import "./chunk--chunk-Z7A6LSGX.vbt.js";

// src/js/components/PredictiveSearch.js
var PredictiveSearch = class {
  constructor(el) {
    this.el = el;
    this.form = el.querySelector("[data-search-form]");
    this.input = el.querySelector("input");
    this.resultsContainer = el.querySelector("[data-results-container]");
    this.emptyQueryContainer = el.querySelector("[data-empty-query-container]");
    this.inputClear = el.querySelector("[data-input-clear]");
  }
  async init() {
    this.form.addEventListener("submit", () => {
      window.location.href = window.location.origin + "/search?q=" + this.input.value;
    });
    this.input.addEventListener("input", (e) => {
      const term = e.target.value.trim();
      this.emptyQueryContainer.classList.toggle("hidden", term.length);
      if (!term.length) {
        this.resultsContainer.innerHTML = "";
        return;
      }
      this.getResults();
    });
    if (this.inputClear)
      this.inputClear.addEventListener("click", () => {
        this.input.value = "";
        this.input.dispatchEvent(new Event("input"));
        this.input.focus();
      });
    this.input.dispatchEvent(new Event("input"));
  }
  getResults() {
    setTimeout(async () => {
      if (this.input.value === "") {
        this.resultsContainer.innerHTML = "";
      } else {
        try {
          const res = await fetch(`/search/suggest?q=${this.input.value}&resources[type]=query,product&resources[options][unavailable_products]=hide&resources[options][fields]=title&section_id=predictive-search`);
          const text = await res.text();
          this.resultsContainer.innerHTML = text;
          this.resultsContainer.querySelectorAll("[data-query]").forEach((button) => {
            const query = button.getAttribute("data-query");
            button.addEventListener("click", () => {
              this.input.value = query;
              this.getResults(query);
            });
          });
          if (this.resultsContainer.querySelector("#predictive-search-results").innerHTML == "") {
            this.emptyQueryContainer.classList.remove("hidden");
            this.resultsContainer.innerHTML.classList.add("hidden");
          }
        } catch (err) {
          console.log(err);
        }
      }
    }, 500);
  }
};
var PredictiveSearch_default = PredictiveSearch;
export {
  PredictiveSearch_default as default
};
